import { Component, Input } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { ModalController } from '@ionic/angular';

export type TAppUpdateModalComponentProps = {
  updateType: 'FLEXIBLE' | 'IMMEDIATE';
  appName: 'Maintaini8';
  currentVersionName?: string;
  availableVersionName?: string;
};

@Component({
  selector: 'ui-app-update-modal',
  templateUrl: './app-update-modal.component.html',
  styleUrls: ['./app-update-modal.component.scss'],
})
export class AppUpdateModalComponent {
  @Input() updateType: TAppUpdateModalComponentProps['updateType'] = 'FLEXIBLE';
  @Input() appName: TAppUpdateModalComponentProps['appName'] = 'Maintaini8';
  @Input() currentVersionName: string = '1.0.0';
  @Input() availableVersionName: string = '1.0.0';

  logoSrcMap: Record<TAppUpdateModalComponentProps['appName'], string> = {
    Maintaini8: 'assets/common/maintaini8-icon.svg',
  };

  constructor(private modalController: ModalController) {}

  async updateNow() {
    if (Capacitor.isNativePlatform()) {
      await AppUpdate.openAppStore();
      if (this.updateType === 'FLEXIBLE') await this.modalController.dismiss();
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
